export function prettyBytes(b) {
  var KB = 1024;
  var MB = KB * 1024;
  var GB = MB * 1024;
  var TB = GB * 1024;
  if (b == 0) {
    return "0";
  } else if (b < KB) {
    return "".concat(b, " B");
  } else if (b < MB) {
    return "".concat(Math.round(b / KB), " KB");
  } else if (b < GB) {
    return "".concat(Math.round(b / MB), " MB");
  } else if (b < TB) {
    return "".concat(Math.round(b / GB), " GB");
  } else {
    return "".concat(Math.round(b / TB), " TB");
  }
}